import { TableRow } from '@shared/UI';
import { IBmoTransaction } from '@shared/api';

interface Options {
    onBmoTransactionViewClick: (bmoTransaction: IBmoTransaction) => void;
}

export function getBmoTransactionsTableRows(options: Options): TableRow<IBmoTransaction> {
    const { onBmoTransactionViewClick } = options;
    return { onClick: (row) => () => onBmoTransactionViewClick(row) };
}
